import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
    Button,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow
} from "@material-ui/core";
import { noImg } from "vrcore-dashboard/dist/utilities";
import moment from "moment";

export default props => {
    const [modalInfo, setModalInfo] = useState(props.modalInfo);
    const [qualificationInfo, setQualificationInfo] = useState(
        props.qualificationInfo
    );
    useEffect(() => {
        setModalInfo(props.modalInfo);
        setQualificationInfo(props.qualificationInfo);
    }, [props.modalInfo, props.qualificationInfo]);
    return (
        <Modal isOpen={modalInfo.state}>
            <ModalHeader>Qualification User Information</ModalHeader>
            {qualificationInfo && (
                <ModalBody style={{ height: "60vh", overflow: "scroll" }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}
                    >
                        <ColorInfo
                            color="#FF6E40"
                            text={`Out Of Date/No Date`}
                        />

                        <ColorInfo color="#ffff00" text={`< 3 Months`} />
                        <ColorInfo color="#00e600" text={`> 3 Months`} />
                    </div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell text="Valid" />
                                <TableHeadCell text="User Name" />
                                <TableHeadCell text="Expiry Date" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {qualificationInfo.map((info, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <img
                                                src={
                                                    info.qualification_img
                                                        ? info.qualification_img
                                                        : noImg
                                                }
                                                style={{ height: 50 }}
                                                alt="Qualificaiton Valid Icon"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {info.user_name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                backgroundColor: checkExpiryDate(
                                                    info.expiry_date
                                                )
                                            }}
                                        >
                                            {info.expiry_date
                                                ? info.expiry_date
                                                : "N/A"}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </ModalBody>
            )}
            <ModalFooter>
                <Button
                    onClick={() => props.setModalInfo(false, false)}
                    variant="contained"
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

const TableHeadCell = ({ text }) => {
    return (
        <TableCell>
            <Typography variant="body2">
                <b>{text}</b>
            </Typography>
        </TableCell>
    );
};
const ColorInfo = ({ text, color }) => {
    return (
        <div style={{ display: "flex", padding: 20 }}>
            <div
                style={{ backgroundColor: color, width: 20, marginRight: 10 }}
            />
            <Typography variant="caption">{text}</Typography>
        </div>
    );
};
const checkExpiryDate = (date = false) => {
    let momentDate = moment(date, "DD-MM-YYYY");
    let currentDate = new moment();
    let futureDate = moment().add(3, "M");
    if (date) {
        if (momentDate.isBefore(currentDate)) {
            return "#FF6E40";
        } else if (momentDate.isAfter(futureDate)) {
            return "#00e600";
        } else {
            return "#ffff00";
        }
    } else {
        return "#FF6E40";
    }
};
